import React, { Component } from 'react';
import Modal from './_Modal';
import styled from 'styled-components';
// var { FaMedium, FaFacebook, FaTwitter, FaGooglePlus } = require('react-icons/lib/fa');
import { ShareButtons, generateShareIcon } from 'react-share';

const { FacebookShareButton, LinkedinShareButton, GooglePlusShareButton,
        TwitterShareButton } = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const LinkedinIcon = generateShareIcon('linkedin');
const GooglePlusIcon = generateShareIcon('google');

const Wrapper = styled.div`
  text-align: center;
`
const Ul = styled.ul`
  box-sizing: border-box;
  list-style-type: none;
  margin: 0;
  padding-left: 0px;
`;
const Li = styled.li`
  float: left;
  padding: 5px 10px 5px 10px;
  margin-left: 10px;
  transform: scale(1.5);
  &:hover {
    color: #fb4d47;
    cursor: pointer;
  }
  text-align: center;
  p {
    transform: scale(0.8);
  }
  ${'' /* border-right: 1px solid lightgrey; */}
  ${'' /* position: relative;
  display: inline-block; */}
`;

class Share extends Component {
  render() {
    const quote = "Check out this Envelope:"
    // console.log(this.props.evkey);
    const { evKey } = this.props;
    return (
      <Wrapper>
        <Modal
          open={this.props.open}
          close={() => this.props.closeModal(this.props.method)}
        >
          <h3>Share this Envelope</h3>
          <hr />
          <Ul>
            <Li>
              <FacebookShareButton url={'https://envelope.li/' + evKey} quote={quote}>
                <FacebookIcon size={24} round />
              </FacebookShareButton>
            </Li>
            <Li>
              <TwitterShareButton url={'https://envelope.li/' + evKey} quote={quote}>
                <TwitterIcon size={24} round />
              </TwitterShareButton>
            </Li>
            <Li>
              <LinkedinShareButton url={'https://envelope.li/' + evKey} quote={quote}>
                <LinkedinIcon size={24} round />
              </LinkedinShareButton>
            </Li>
            <Li>
              <GooglePlusShareButton url={'https://envelope.li/' + evKey} quote={quote}>
                <GooglePlusIcon size={24} round />
              </GooglePlusShareButton>
            </Li>
          </Ul>
          {/* <hr />
          <FaMedium /><p>Embed your envelope</p> */}
        </Modal>
      </Wrapper>
    )
  }
}

export default Share;



// WEBPACK FOOTER //
// ./src/_ShareModal.js